module.exports = __webpack_public_path__ + "img/SmartTV_W600D.e18d2a4e.png";